import { render, staticRenderFns } from "./BCXMessengerNewChatPanel.vue?vue&type=template&id=d7b5d3fa&scoped=true"
import script from "./BCXMessengerNewChatPanel.vue?vue&type=script&lang=ts"
export * from "./BCXMessengerNewChatPanel.vue?vue&type=script&lang=ts"
import style0 from "./BCXMessengerNewChatPanel.vue?vue&type=style&index=0&id=d7b5d3fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7b5d3fa",
  null
  
)

export default component.exports